import { footerBg3Style, wallet } from "@/assets";

export function WalletTransactionsSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`wallet-tx-${index}`}
          className="flex items-center justify-between rounded-xl border border-gray-100 bg-white p-4 shadow-sm"
        >
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-4 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-3 w-48 animate-pulse rounded bg-[#F0E0C7]/60" />
            <div className="h-3 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
          </div>
          <div className="ml-4 h-5 w-16 shrink-0 animate-pulse rounded bg-[#F0E0C7]/60" />
        </div>
      ))}
    </div>
  );
}

export default function WalletPageSkeleton() {
  return (
    <>
      <div className="px-4">
        <div
          className="relative mx-auto mt-4 flex min-h-48 flex-col items-center justify-center rounded-3xl bg-cover bg-center p-6"
          style={{ backgroundImage: `url(${wallet})` }}
        >
          <div className="h-4 w-28 animate-pulse rounded bg-white/40" />
          <div className="mt-3 h-10 w-40 animate-pulse rounded bg-white/40" />
        </div>
        <div className="mt-4 flex gap-6">
          {Array.from({ length: 2 }).map((_, index) => (
            <div key={`wallet-option-${index}`} className="flex items-center gap-3">
              <div className="h-4 w-4 animate-pulse rounded-full bg-[#F0E0C7]/60" />
              <div className="h-4 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
            </div>
          ))}
        </div>
      </div>
      <div
        className="mt-4 min-h-[calc(100vh-13.5rem)] rounded-t-3xl bg-white p-6 pb-27.5 lg:mx-auto"
        style={footerBg3Style}
      >
        <div className="mb-4 flex items-center justify-between">
          <div className="h-7 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-9 w-36 animate-pulse rounded-lg bg-[#F0E0C7]/60" />
        </div>
        <WalletTransactionsSkeleton />
      </div>
    </>
  );
}
